/* src/app/maps/maps.component.scss */
.usa-map-card {
  width: 100%;
  padding: 6px 24px;
  overflow: hidden;
}
.map-header {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border-bottom: 1px solid #edf0f4;
}
.map-title-section {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 14px;
}
.map-icon,
.state-location-icon {
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #eef2ff;
  color: #253b80;
}
.map-icon i {
  font-size: 19px;
}
.map-heading {
  min-width: 0;
}
.map-heading h3 {
  margin: 0;
  color: #111827;
  font-size: 21px;
  line-height: 1.35;
  font-weight: 700;
}
.map-heading p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.5;
}
.map-actions {
  flex: 0 0 auto;
}
.select-all-btn {
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  border: 1px solid #d7deeb;
  border-radius: 10px;
  background: #ffffff;
  color: #253b80;
  font-size: 14px;
  font-weight: 650;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}
.select-all-btn i {
  font-size: 14px;
}
.select-all-btn:hover {
  background: #f5f7ff;
  border-color: #253b80;
  transform: translateY(-1px);
  box-shadow: 0 5px 12px rgba(37, 59, 128, 0.08);
}
.select-all-btn:active {
  transform: translateY(0);
}
.select-all-btn:focus-visible {
  outline: 3px solid rgba(37, 59, 128, 0.15);
  outline-offset: 2px;
}
.map-content {
  display: grid;
  grid-template-columns: minmax(0, 2.55fr) minmax(330px, 0.9fr);
  gap: 22px;
  padding-top: 22px;
}
.map-panel {
  min-width: 0;
  min-height: 570px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 17px;
}
.map-wrapper {
  position: relative;
  flex: 1;
  min-height: 570px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px;
  overflow: hidden;
  background:
    radial-gradient(
      circle at center,
      #ffffff 0%,
      #f8fafc 58%,
      #f1f5f9 100%);
}
.map-background {
  position: absolute;
  inset: 20px;
  border-radius: 15px;
  background-image:
    linear-gradient(rgba(37, 59, 128, 0.025) 1px, transparent 1px),
    linear-gradient(
      90deg,
      rgba(37, 59, 128, 0.025) 1px,
      transparent 1px);
  background-size: 30px 30px;
  pointer-events: none;
}
.usa-map {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 761px;
  height: 500px;
  border: 0;
  background: transparent;
  transition: transform 0.25s ease;
}
.usa-map:hover {
  transform: scale(1.01);
}
.state-panel {
  position: relative;
  min-width: 0;
  min-height: 570px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e2e7ef;
  border-radius: 17px;
}
.state-details {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 22px;
}
.state-details-header {
  display: flex;
  align-items: center;
  gap: 13px;
}
.state-location-icon i {
  font-size: 18px;
}
.state-label {
  display: block;
  margin-bottom: 2px;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.4;
  font-weight: 650;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.state-details-header h4 {
  margin: 0;
  color: #111827;
  font-size: 18px;
  line-height: 1.35;
  font-weight: 700;
}
.state-divider {
  width: 100%;
  height: 1px;
  margin: 20px 0;
  background: #edf0f4;
}
.documents-section {
  min-height: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.state-document-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 390px;
  overflow-y: auto;
  padding-right: 3px;
}
.state-document-list::-webkit-scrollbar {
  width: 6px;
}
.state-document-list::-webkit-scrollbar-track {
  background: transparent;
}
.state-document-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.state-document-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.state-document-item {
  width: 100%;
  min-height: 56px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 12px;
  background: #f8fafc;
  border: 1px solid #e4e8ef;
  border-radius: 12px;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}
.state-document-item:hover {
  background: #ffffff;
  border-color: #cbd5e1;
  transform: translateY(-1px);
  box-shadow: 0 5px 14px rgba(15, 23, 42, 0.06);
}
.document-file-icon {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #eef2ff;
  color: #253b80;
}
.document-file-icon i {
  font-size: 16px;
}
.document-content {
  min-width: 0;
  flex: 1;
}
.document-title {
  display: -webkit-box;
  overflow: hidden;
  color: #334155;
  font-size: 14px;
  line-height: 1.45;
  font-weight: 500;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.document-meta {
  display: flex;
  align-items: center;
  margin-top: 5px;
}
.document-meta span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.4;
}
.document-meta span i {
  font-size: 11px;
}
.document-view-btn {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dbe1ea;
  border-radius: 9px;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}
.document-view-btn i {
  font-size: 14px;
}
.document-view-btn:hover {
  background: #253b80;
  border-color: #253b80;
  color: #ffffff;
  transform: translateY(-1px);
}
.document-view-btn:focus-visible {
  outline: 3px solid rgba(37, 59, 128, 0.15);
  outline-offset: 2px;
}
.documents-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: auto;
  padding-top: 18px;
  border-top: 1px solid #edf0f4;
}
.continue-btn {
  min-width: 130px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 17px;
  border: 0;
  border-radius: 10px;
  background: #253b80;
  color: #ffffff;
  font-size: 14px;
  font-weight: 650;
  cursor: pointer;
  transition:
    background 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}
.continue-btn:hover {
  background: #344f91;
  transform: translateY(-1px);
  box-shadow: 0 7px 16px rgba(37, 59, 128, 0.18);
}
.continue-btn:active {
  transform: translateY(0);
}
.no-state-documents {
  min-height: 320px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  text-align: center;
}
.empty-document-icon {
  width: 62px;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  border-radius: 16px;
  background: #f1f5f9;
  color: #64748b;
}
.empty-document-icon i {
  font-size: 25px;
}
.no-state-documents strong {
  color: #334155;
  font-size: 16px;
  line-height: 1.4;
  font-weight: 700;
}
.no-state-documents > span {
  max-width: 280px;
  margin-top: 7px;
  color: #94a3b8;
  font-size: 13px;
  line-height: 1.6;
}
.state-empty {
  width: 100%;
  min-height: 570px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 30px;
  text-align: center;
  background: #ffffff;
  border: 1px dashed #d7dce5;
  border-radius: 16px;
}
.state-empty h4 {
  margin: 0 0 8px;
  color: #111827;
  font-size: 18px;
  line-height: 1.4;
  font-weight: 700;
}
.state-empty p {
  max-width: 300px;
  margin: 0;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.65;
}
.empty-map-icon {
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  border-radius: 20px;
  background: #eef2ff;
  color: #253b80;
  font-size: 29px;
}
.document-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.6);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  animation: documentBackdropIn 0.2s ease-out;
}
.document-modal {
  width: min(1180px, 100%);
  height: min(90vh, 860px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.22), 0 8px 24px rgba(15, 23, 42, 0.08);
  animation: documentModalIn 0.25s ease-out;
}
.document-modal-header {
  min-height: 78px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 14px 20px;
  flex-shrink: 0;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}
.document-modal-title {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 13px;
}
.document-modal-title h3 {
  max-width: 760px;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #111827;
  font-size: 17px;
  line-height: 1.4;
  font-weight: 650;
}
.modal-file-icon {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: rgba(37, 59, 128, 0.09);
  color: #253b80;
  font-size: 20px;
}
.modal-close-btn {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #ffffff;
  color: #64748b;
  font-size: 17px;
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}
.modal-close-btn:hover {
  background: #f4f6fa;
  border-color: #d1d5db;
  color: #253b80;
}
.modal-close-btn:active {
  transform: scale(0.94);
}
.modal-close-btn:focus-visible {
  outline: 3px solid rgba(37, 59, 128, 0.15);
  outline-offset: 2px;
}
.document-modal-body {
  min-height: 0;
  flex: 1;
  display: flex;
  overflow: hidden;
  background: #f4f6fa;
}
.viewer-section {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  padding: 18px;
  overflow: hidden;
}
.document-preview {
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e1e6ef;
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
}
.document-preview ngx-doc-viewer {
  display: block;
  width: 100%;
  height: 100%;
}
.media-viewer {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #0f172a;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.12);
}
.media-viewer vg-player {
  width: 100%;
  height: 100%;
}
.media-viewer video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #0f172a;
}
.loader-container {
  width: 100%;
  height: 100%;
  min-height: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}
.loader-container h4 {
  margin: 0 0 7px;
  color: #111827;
  font-size: 16px;
  line-height: 1.4;
  font-weight: 650;
}
.loader-container p {
  max-width: 420px;
  margin: 0;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.6;
}
.loader-icon {
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  border-radius: 50%;
  background: rgba(37, 59, 128, 0.08);
  color: #253b80;
  font-size: 25px;
}
.document-modal-footer {
  min-height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 12px 20px;
  flex-shrink: 0;
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
}
.footer-info {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 9px;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
}
.footer-info i {
  flex: 0 0 auto;
  color: #253b80;
  font-size: 15px;
}
.footer-info span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.modal-secondary-btn {
  min-width: 92px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  border: 1px solid #d7dce5;
  border-radius: 9px;
  background: #ffffff;
  color: #334155;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}
.modal-secondary-btn:hover {
  background: #f4f6fa;
  border-color: #253b80;
  color: #253b80;
}
.modal-secondary-btn:active {
  transform: translateY(1px);
}
.modal-secondary-btn:focus-visible {
  outline: 3px solid rgba(37, 59, 128, 0.15);
  outline-offset: 2px;
}
.map-legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 18px;
  margin-top: 18px;
  padding: 14px 18px;
}
.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #475569;
}
.legend-color {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  border-radius: 4px;
  border: 1px solid rgba(15, 23, 42, 0.12);
}
.legend-color.paid {
  background: #8fa8d8;
  border-color: #253b80;
}
.legend-color.available {
  background: #22c55e;
  border-color: #15803d;
}
.legend-color.unavailable {
  background: #e5e7eb;
  border-color: #cbd5e1;
}
.legend-color.selected {
  background: #253b80;
  border-color: #253b80;
}
@keyframes documentBackdropIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes documentModalIn {
  from {
    opacity: 0;
    transform: translateY(18px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 1100px) {
  .map-content {
    grid-template-columns: minmax(0, 1.3fr) minmax(300px, 0.9fr);
  }
  .map-panel,
  .map-wrapper,
  .state-panel {
    min-height: 520px;
  }
  .usa-map {
    height: 450px;
  }
}
@media (max-width: 850px) {
  .usa-map-card {
    padding: 14px 18px;
  }
  .map-content {
    grid-template-columns: 1fr;
  }
  .map-panel,
  .map-wrapper {
    min-height: 500px;
  }
  .state-panel {
    min-height: 420px;
  }
  .usa-map {
    height: 430px;
  }
}
@media (max-width: 600px) {
  .usa-map-card {
    padding: 12px;
  }
  .map-header {
    align-items: stretch;
    flex-direction: column;
    gap: 14px;
    padding-bottom: 16px;
  }
  .map-heading h3 {
    font-size: 19px;
  }
  .map-heading p {
    font-size: 13px;
  }
  .map-actions,
  .select-all-btn {
    width: 100%;
  }
  .map-content {
    gap: 14px;
    padding-top: 14px;
  }
  .map-panel,
  .map-wrapper {
    min-height: 380px;
  }
  .map-wrapper {
    padding: 10px;
  }
  .usa-map {
    height: 350px;
  }
  .state-panel {
    min-height: 400px;
  }
  .state-details {
    padding: 17px;
  }
  .state-document-list {
    max-height: 300px;
  }
  .document-modal-backdrop {
    align-items: flex-end;
    padding: 0;
  }
  .document-modal {
    width: 100%;
    height: 94vh;
    max-height: 94vh;
    border-radius: 18px 18px 0 0;
  }
  .document-modal-header {
    min-height: 68px;
    gap: 10px;
    padding: 11px 14px;
  }
  .modal-file-icon {
    width: 40px;
    height: 40px;
    flex-basis: 40px;
    font-size: 18px;
  }
  .document-modal-title h3 {
    max-width: calc(100vw - 120px);
    font-size: 15px;
  }
  .modal-close-btn {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
  }
  .viewer-section {
    padding: 10px;
  }
  .document-preview,
  .media-viewer {
    border-radius: 10px;
  }
  .document-modal-footer {
    min-height: 62px;
    padding: 10px 14px;
  }
  .footer-info {
    font-size: 12px;
  }
  .modal-secondary-btn {
    min-width: 78px;
    height: 38px;
    padding: 0 14px;
    font-size: 13px;
  }
}
@media (max-width: 380px) {
  .map-heading h3 {
    font-size: 18px;
  }
  .map-panel,
  .map-wrapper {
    min-height: 320px;
  }
  .map-wrapper {
    padding: 5px;
  }
  .usa-map {
    height: 290px;
  }
  .state-document-item {
    padding: 9px;
    gap: 9px;
  }
  .document-file-icon {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
  }
  .document-view-btn {
    width: 34px;
    height: 34px;
    flex-basis: 34px;
  }
  .documents-footer {
    padding-top: 14px;
  }
  .continue-btn {
    width: 100%;
  }
  .document-modal-footer {
    flex-direction: column;
    align-items: stretch;
  }
  .footer-info {
    justify-content: center;
  }
  .modal-secondary-btn {
    width: 100%;
  }
}
/*# sourceMappingURL=maps.component.css.map */
